import { render, staticRenderFns } from "./drip-campaign-edit-header-loader.vue?vue&type=template&id=042c5204"
import script from "./drip-campaign-edit-header-loader.vue?vue&type=script&lang=js"
export * from "./drip-campaign-edit-header-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports